<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import { Input, Article, Select, Badge, Switch, Modal } from 'spaper';
  import { strings, regex } from "../constants/strings";
  import { loadAdoptableInfo, uploadAdoptionRequest } from "../utils/utils";
  import HeaderMini from '../components/HeaderMini.svelte';
  import Footer from "../components/Footer.svelte";
  import ActionButton from "../components/ActionButton.svelte";

  export let id;
  export let kind;
  let adoptableName;
  let activeModal = false;

  // Form data
  let formError = "";
  let adopterName = "";
  let adopterPhone = "";
  let adopterEmail = "";
  let adopterLocation = "";
  let adopterComments = "";
  let adopterHasHadPets = false;

  
  const getAdoptableInfo = async () => {
    try {
      const adoptableData = await loadAdoptableInfo(id, kind);
      adoptableName = adoptableData.name;
    } catch(errorMessage) {
      formError = errorMessage;
    }
  };

  const _validateForm = () => {
    formError = "";
    if (!adopterName || !adopterPhone || !adopterEmail || !adopterLocation || !adopterComments) {
      formError = strings.formMessages.validation.allFieldsRequired;
      return false;
    }
    if (!regex.email.test(adopterEmail)) {
      formError = strings.formMessages.validation.invalidEmail;
      return false;
    }
    if (!regex.phoneNumber.test(adopterPhone)) {
      formError = strings.formMessages.validation.invalidPhoneNumber;
      return false;
    }
    return true;
  };

  const _buildFormData = () => {
    const formData = new FormData();
    formData.append("adoptable_id", id);
    formData.append("adoptable_kind", kind);
    formData.append("adoptable_name", adoptableName);
    formData.append("name", adopterName);
    formData.append("phone", adopterPhone);
    formData.append("email", adopterEmail);
    formData.append("location", adopterLocation);
    formData.append("comments", adopterComments);
    formData.append("had_pets", adopterHasHadPets);
    return formData;
  };

  const submitForm = async () => {
    if (!_validateForm()) return;
    try {
      const data = _buildFormData();
      await uploadAdoptionRequest(data);
      activeModal = true;
      setTimeout(() => {
        navigate("/");
      }, 2300);
    } catch (errorMessage) {
      formError = errorMessage;
    }
  };

  onMount(getAdoptableInfo);
</script>

<HeaderMini />
<Article title="¡Gracias por tu interés!">
  <p slot="textLead">
    Déjanos tus datos y nosotros te contactaremos a la brevedad
  </p>
  <div class="form-group">
    <Input bind:value={adopterName} label="Nombre Completo:" maxlength="40" block />
    <Input bind:value={adopterPhone} label="Teléfono de contacto (10 dígitos):" maxlength="10" block />
    <Input bind:value={adopterEmail} label="Correo electrónico:" maxlength="40" block />
    <Select bind:value={adopterLocation}>
      <option value="">¿En dónde te encuentras?</option>
      {#each Object.keys(strings.locations) as loc}
        <option value={loc}>{strings.locations[loc]}</option>  
      {/each}
    </Select>
    <p>
      Comentarios:
      <Input bind:value={adopterComments} placeholder="¿Por qué te interesa adoptar a {adoptableName}?" type="textarea" noResize block />
    </p>
    <p>
      ¿Has tenido mascotas anteriormente?
      <br />
      <Switch bind:checked={adopterHasHadPets}>
        {adopterHasHadPets ? "Sí" : "No"}
      </Switch>
    </p>
    <br>
    {#if formError != ""}
      <Badge type="danger">{formError}</Badge>
      <br />
      <br />
    {/if}
    <ActionButton klass="btn-danger" action={submitForm} text="Enviar" />
  </div>
</Article>
<Modal title="Gracias" closeBtnText="Cerrar" bind:active={activeModal}>
  Tu solicitud ha sido enviada con éxito. Pronto nos pondremos en contacto.
</Modal>
<Footer />